let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("hcsg0")).then(() => parcelRequire('lmzTx'));